import { graphql } from "~/gql";

export const CREATE_PHASE = graphql(/* GraphQL */ `
  mutation createAndAddPhase($data: PhaseCreateInput!, $matterId: Float!) {
    createAndAddPhase(data: $data, matterId: $matterId) {
      ...PhaseParts
    }
  }
`);

export const CREATE_PHASES = graphql(/* GraphQL */ `
  mutation createAndAddPhases($data: [PhaseCreateInput!]!, $matterId: Float!) {
    createAndAddPhases(data: $data, matterId: $matterId) {
      ...PhaseParts
    }
  }
`);
